import { Button, Checkbox, Icon, Input, Modal, Radio, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { HOTEL, ORDER } from '../../../../../../constants/Define'
import { FormWrapperItem } from '../../../../common/component/Index'
import Wrapper from '../../../../common/component/Wrapper'
import DualListBox from 'react-dual-listbox'
import * as Func from '../../../../../../helpers/functions'
import * as HMS from "../../../../common/component/Index";
import AntSelect, { AntOption } from '../../../../common/component/AntSelect';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import './ListHotel.less';
import CONFIG from "../../../../../../constants/Config";
import { filter } from 'lodash'
import { fillHotelNameForRatePlan } from '../../../../../../utils/commonUtils'

let permissionActions = [];
const CheckboxGroup = Checkbox.Group
const EMPTY_LIST = [];
const ListHotel = ({ ...props }) => {
    const { t } = useTranslation();
    const {
        allHotels = [],
        allHomestays = [],
        className,
        buttonText,
        getAllHotel,
        getAllHomestay,
        onChange,
        getListRatesByHotels,
        getListRatesByHomestays,
        rateState = {},
        homestayRateState = {},
        action,
        hotelData,
        campaign = {},
    } = props;
    const { isFetchingRatesByHotels, dataListRateByHotels } = rateState || {};
    const { isFetchingHomestayRatesByHomestays, dataListHomestayRateByHomestays } = homestayRateState || {};
    const safeCampaign = campaign || {};
    const safeAllHotels = Array.isArray(allHotels) ? allHotels : EMPTY_LIST;
    const safeAllHomestays = Array.isArray(allHomestays) ? allHomestays : EMPTY_LIST;
    const safeDataListRateByHotels = Array.isArray(dataListRateByHotels) ? dataListRateByHotels : EMPTY_LIST;
    const safeDataListHomestayRateByHomestays = Array.isArray(dataListHomestayRateByHomestays) ? dataListHomestayRateByHomestays : EMPTY_LIST;
    const [visible, setVisible] = useState(false);
    const [hotelIds, setHotelIds] = useState([]);
    const [ratePlanSelected, setRatePlanSelected] = useState([]);
    const [allRatePlan, setAllRatePlan] = useState([]);
    const [rateType, setRateType] = useState([]);
    const [filterStatus, setFilterStatus] = useState(null)
    const [ratePlanFilter, setRatePlanFilter] = useState({ available: '', selected: '' });
    const [isOnBlurHotel, setIsOnBlurHotel] = useState(true);
    const [isCheckHotelIds, setIsCheckHotelIds] = useState(false);

    useEffect(() => {
        if (safeCampaign.isCampaignStaynFun) {
            getAllHomestay && getAllHomestay();
        } else {
            getAllHotel && getAllHotel();
        }
    }, [safeCampaign.isCampaignStaynFun]);

    useEffect(() => {
        if ((hotelIds.length > 0 && hotelIds.length === safeAllHotels.length) ||
            (hotelIds.length > 0 && hotelIds.length === safeAllHomestays.length))
        {
            setIsCheckHotelIds(true)
            return;
        } return setIsCheckHotelIds(false);
    }, [hotelIds, safeAllHotels, safeAllHomestays])

    useEffect(() => {
        if (hotelIds && hotelIds.length > 0) {
            setRatePlanSelected([...ratePlanSelected]);
            setAllRatePlan([...fillHotelNameForRatePlan({
                allHotels: safeCampaign.isCampaignStaynFun ? safeAllHomestays : safeAllHotels,
                dataListRateByHotels: safeCampaign.isCampaignStaynFun ? safeDataListHomestayRateByHomestays : safeDataListRateByHotels
            })]);
        } else {
            setAllRatePlan([]);
        }
    }, [safeDataListRateByHotels, safeDataListHomestayRateByHomestays]);

    useEffect(() => {
        if (!isOnBlurHotel && visible) {
            const request = {
                hotelIds: hotelIds,
                dc: rateType,
            }
            if(filterStatus !== null) {
                request.active = filterStatus
            }
            if (safeCampaign.isCampaignStaynFun) {
                getListRatesByHomestays && getListRatesByHomestays(request);
            } else {
                getListRatesByHotels && getListRatesByHotels(request);
            }
        }
    }, [hotelIds, rateType, filterStatus]);

    useEffect(() => {
        if (hotelData && hotelData.length > 0 && visible) {
            const hotels = [];
            const arrRateCodes = [];
            hotelData.map(item => {
                if (hotels && !hotels.includes(item.id))
                    hotels.push(item.id);
                const rateCodes = item.rateCodes;
                if (rateCodes && rateCodes.length > 0) {
                    rateCodes.map(itemRate => {
                        arrRateCodes.push(`${ item.id }:${ itemRate }`);
                    })
                }
            });
            setRatePlanSelected([...arrRateCodes]);
            setHotelIds([...hotels]);
            const request = {
                hotelIds: hotels,
                dc: rateType,
            }
            if(filterStatus !== null) {
                request.active = filterStatus
            }
            if (safeCampaign.isCampaignStaynFun) {
                getListRatesByHomestays && getListRatesByHomestays(request);
            } else {
                getListRatesByHotels && getListRatesByHotels(request);
            }
            selectedItemFunc();
        }
    }, [hotelData, visible]);

    const showModal = () => {
        setVisible(true);
    };

    const handleOk = () => {
        onChange && onChange(hotelIds, ratePlanSelected);
        setVisible(false);
        clearData();
    };

    const handleCancel = () => {
        setVisible(false);
        clearData();
    };

    const onChangeHotel = (ids) => {
        ids = Array.isArray(ids) ? ids : [];
        const cloneHotel = safeCampaign.isCampaignStaynFun ?
            safeAllHomestays.map((el) => el.id) :
            safeAllHotels.map((el) => el.id);
        const isSelectAll = ids.includes('all');
        if(isSelectAll){
            setHotelIds(cloneHotel);
            return;

        }
        setHotelIds(ids);
        if (ids && ids.length <= 0) {
            setRateType([]);
        }
    };

    const onBlurHotel = () => {
        setIsOnBlurHotel(false);
        if ( hotelIds && hotelIds.length > 0) {
            setRatePlanSelected([...ratePlanSelected]);
            setAllRatePlan([...fillHotelNameForRatePlan({
                allHotels: safeCampaign.isCampaignStaynFun ? safeAllHomestays : safeAllHotels,
                dataListRateByHotels: safeCampaign.isCampaignStaynFun ? safeDataListHomestayRateByHomestays : safeDataListRateByHotels
            })]);
            if (visible) {
                const request = {
                    hotelIds: hotelIds,
                    dc: rateType,
                }
                if(filterStatus !== null) {
                    request.active = filterStatus
                }
                if (safeCampaign.isCampaignStaynFun) {
                    getListRatesByHomestays && getListRatesByHomestays(request);
                } else {
                    getListRatesByHotels && getListRatesByHotels(request);
                }
            }
        } else {
            setAllRatePlan([]);
        }
        
    }
    const onChangeRates = (selected) => {
        setRatePlanSelected(selected);
    };

    const clearData = () => {
        setHotelIds([]);
        setRatePlanSelected([]);
        setAllRatePlan([]);
        setRateType([]);
        setRatePlanFilter({ available: '', selected: '' });
    }

    const selectedItemFunc = () => {
        return ratePlanSelected;
    }

    const normalizeFilterText = (value) => {
        return Func.vietnameseStringToUnicode(`${value || ''}`.trim().toLowerCase());
    }

    const getRatePlanOptions = (filterInput) => {
        const inputText = normalizeFilterText(filterInput);
        const selectedValues = Array.isArray(ratePlanSelected) ? ratePlanSelected : [];
        return (allRatePlan || []).filter(Boolean).reduce((options, item) => {
            const ratePlans = (Array.isArray(item.ratePlans) ? item.ratePlans : [])
                .filter(Boolean)
                .map(itemRate => ({
                    ...itemRate,
                    label: itemRate.code,
                    value: `${ item.id }:${ itemRate.code }`,
                }))
                .filter(itemRate => selectedValues.includes(itemRate.value) || !inputText || normalizeFilterText(itemRate.label).includes(inputText));

            if (ratePlans.length > 0) {
                options.push({
                    label: item.name,
                    options: ratePlans,
                });
            }

            return options;
        }, []);
    }

    const getTypeRate = () => {
        let result = [];
        const typeRateByConfigEnv = HOTEL.TYPE_RATE[CONFIG.ENV];
        if (typeRateByConfigEnv) {
            const entriesArr = Object.entries(typeRateByConfigEnv);
            if (entriesArr && entriesArr.length > 0) {
                entriesArr.map(item => {
                    if (item && item.length === 2) {
                        const key = item[0];
                        const label = item[1];
                        const existed = result.filter(itemRate => {
                            return itemRate.value === key
                        });
                        if (existed && existed.length <= 0) {
                            result.push({
                                label: label,
                                value: key,
                            })
                        }
                    }
                })
            }
        }
        return result;
    }

    const onChangeTypeRate = list => {
        setRateType([...list]);
    }

    const selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option.props?.children?.props?.children?.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

    return (
        <Fragment>
            <Button className={ className } type="primary" onClick={ showModal }>
                { buttonText || t(`item.campaign.selectHotel`) }
            </Button>
            <Modal title={ t(`item.campaign.selectHotel`) }
                   width={ 1200 }
                   visible={ visible }
                   onOk={ handleOk }
                   onCancel={ handleCancel }
                   maskClosable={ false }
                   okButtonProps={{
                       disabled: isFetchingRatesByHotels || isFetchingHomestayRatesByHomestays
                   }}
            >
                <FormWrapperItem classParent='wt-box-content'>
                    <Wrapper className='col-md-10'>
                        <AntSelect className="select-types"
                                   showArrow
                                   allowClear
                                   placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.promotions.hotel")).toLowerCase()) }
                                   value={ hotelIds }
                                   onFocus={() => {setIsOnBlurHotel(true)}}
                                   onChange={ ids => {
                                       onChangeHotel(ids)
                                   } }
                                   onBlur={() => onBlurHotel()}
                                   style={ { width: '100%' } }
                                   mode="multiple"
                                   filterOption={selectFilterSearch}

                        >
                            <AntOption value='all' disabled={isCheckHotelIds}>
                                <Tooltip title={t(`item.campaign.selectAllHotel`)} placement="topLeft">
                                   {t(`item.campaign.selectAllHotel`)}
                                </Tooltip>
                            </AntOption>
                            {(safeCampaign.isCampaignStaynFun ? safeAllHomestays : safeAllHotels).filter(Boolean).map(hotel => (
                                <AntOption key={ hotel.id } value={ hotel.id }>
                                    <Tooltip title={ hotel.name } placement="topLeft">{ `${ hotel.code } - ${ hotel.name }` }</Tooltip>
                                </AntOption>
                            )) }
                        </AntSelect>
                    </Wrapper>
                    <Wrapper className='col-md-2'>
                        <CheckboxGroup
                            disabled={hotelIds && hotelIds.length <= 0}
                            className="mt-8"
                            options={ getTypeRate() }
                            onChange={ onChangeTypeRate }
                            value={ rateType }
                        />
                    </Wrapper>
                </FormWrapperItem>
                <div className="d-flex filter-rate">
                    <span className="label-filter">
                        {t(`item.campaign.filterStatus`)}:
                    </span>
                    <Radio.Group 
                        value={filterStatus}
                        onChange={e => setFilterStatus(e.target.value)}
                        disabled={allRatePlan.length === 0 }
                    >
                        <Radio key={0} value={true}>{t(`item.campaign.active`)}</Radio>
                        <Radio key={1} value={false}>{t(`item.campaign.deactive`)}</Radio>
                        <Radio key={2} value={null}>{t(`item.campaign.all`)}</Radio>
                    </Radio.Group>
                </div>
                <HMS.LoadingComponent spinning={isFetchingRatesByHotels || isFetchingHomestayRatesByHomestays }>
                    <Wrapper className='col-md-12 dual-list-apply-hotel'>
                        <div className="dual-list-custom-filter">
                            <Input
                                value={ratePlanFilter.available}
                                onChange={e => setRatePlanFilter({ ...ratePlanFilter, available: e.target.value })}
                                placeholder={ t('action.search') }
                            />
                            <Input
                                disabled
                                value={ratePlanFilter.selected}
                                placeholder={ t('action.search') }
                            />
                        </div>
                        <DualListBox
                            key={`rate-plan-${normalizeFilterText(ratePlanFilter.available)}`}
                            options={ getRatePlanOptions(ratePlanFilter.available) }
                            selected={ [...ratePlanSelected] }
                            onChange={ onChangeRates }
                            icons={ {
                                moveLeft: <Icon type="left" className="mx-2"/>,
                                moveAllLeft: <Icon type="double-left" className="mx-2"/>,
                                moveRight: <Icon type="right" className="mx-2"/>,
                                moveAllRight: <Icon type="double-right" className="mx-2"/>,
                            } }
                            disabled={ !allRatePlan || (allRatePlan && allRatePlan.length <= 0) }
                        />
                    </Wrapper>
                </HMS.LoadingComponent>
            </Modal>
        </Fragment>
    )
}

export default ListHotel;
